<template>
  <div class="layout-page">
    <top id="top-nav" :title="bookTitle" :key="`${bookInfo.bookId}-home`"></top>
    <div class="aui-footer aui-footer-fixed book-foot" style="padding:0">
      <div class="put-shelf active" @click="addShelf">
        <img src="../../../assets/img/shelf-a-ico.png" />
        <span>{{addedToShelf ? '移除书架' : '加入书架'}}</span>
      </div>
      <div class="read" @click="toReadHandler('history')" v-if="history">
        <span>开始阅读</span>
      </div>
      <div class="read" @click="toReadHandler()" v-else>
        <span>开始阅读</span>
      </div>
    </div>
    <div :id="`scroll-div-book-home-${this.$route.params.id}`" class="aui-scrollView">
      <!-- <div class="no-hairlines">
        <div class="bookmain">
          <div class="cover">
            <img style="width: 100%;" :src="getCover()" />
          </div>
          <div class="bkname">
            <h3>
              <span>{{bookInfo.title}}</span>
              <span
                :class="{'tag-green': bookInfo.publishStatus === 'finish', 'tag-red': bookInfo.publishStatus === 'serialize'}"
              >{{bookInfo.publishStatus === 'serialize' ? '连载中' : bookInfo.publishStatus === 'finish' ? '已完结' : ''}}</span>
            </h3>
            <div>
              <span class="info">
                <label>作者:</label>柯南
              </span>
              <span class="info">
                <label>类型:</label>
                {{bookInfo.categoryName}}
              </span>
              <span class="info">
                <label>阅读量:</label>
                {{bookInfo.readCount}}
              </span>
            </div>
          </div>

          <div class="btnbox-bk">
            <div class="col">
              <a class="btn btn-o" @click="addShelf">{{addedToShelf ? '移除书架' : '加入书架'}}</a>
            </div>
            <div class="col">
              <a class="btn btn-f" @click="toReadHandler('history')">开始阅读</a>
            </div>
          </div>

          <p class="book-desc">{{bookInfo.abstractContent}}</p>
        </div>

        <div class="item-link" @click="toReadHandler('last')">
          <h5 class="t1">最新</h5>
          <div class="item-after">
            <span class="margin-right-sm">{{lastChapter.title}}</span>
            &nbsp;&nbsp;{{getPriceText(lastChapter.price)}}
          </div>
        </div>

        <div class="item-link" @click="toCatalog">
          <h5 class="t2">目录</h5>
          <div class="item-after">共{{bookInfo.chapterCount}}</div>
        </div>
      </div>-->
      <div class="detail-mask" :style="getCoverStyle()"></div>
      <div class="book-detail">
        <div class="cover">
          <img :imgPath="getCoverPlaceholder(bookInfo.cover)"  v-lazy="require('../../../assets/img/loading.jpeg')"/>
        </div>
        <div class="title">
          <h3>{{bookInfo.title}}</h3>
          <span>{{bookInfo.categoryName}}</span>
          <span class="ml15">类型：{{bookInfo.categoryName}}</span>
          <div class="aui-flex-box">
            <span class="i-c" v-if="bookInfo.publishStatus === 'serialize'">连载中</span>
            <span class="i-b" v-else>已完结</span>
          </div>
        </div>
      </div>
      <div style="clear: both;"></div>
      <div class="intro" :class="{'auto': showIntro}">
        <span class="content">{{getContent}}</span>
      </div>
      <div
        class="more"
        v-if="bookInfo.abstractContent &&bookInfo.abstractContent.length > 75"
        :class="{'up': showIntro}"
        @click="showIntro = !showIntro"
      >
        <img src="../../../assets/img/down.png" />
      </div>
      <div class="menu" @click="toCatalog">
        <a>
          目录
          <span>共{{bookInfo.chapterCount}}章</span>
        </a>
      </div>
      <a class="history-r" @click="toReadHandler('history')" v-if="history">
        <span class="bg-red">上次阅读</span>
        <span>{{history.title}}</span>
        <span class="c-red">继续阅读</span>
      </a>
      <a class="history-r" @click="toReadHandler('last')">
        <span class="bg-red">最新</span>
        <span>{{lastChapter.title}}</span>
        <!-- <span class="c-red">继续阅读</span> -->
      </a>
      <div class="divHeight"></div>
      <!-- <books-small title="同类推荐"  :books="recommends"></books-small> -->
      <books-normal :title="'看过本书的还爱看'" :books="recommends" :show-more="false"></books-normal>
      <!-- <div
        id="show-history-modal"
        v-if="showModal && !!history"
        class="fixed-confirm"
        style="display: block;"
      >
        <div class="fixed-c">
          <h3>上次阅读到第{{history ? history.number : ''}}话， 是否继续阅读？</h3>
          <div class="btnbox">
            <button class="btn" type="button" @click="toReadHandler('history')">确定</button>
            <button class="btn close" type="button" @click="hideModal">取消</button>
          </div>
        </div>
      </div>-->
    </div>
  </div>
</template>

<script>
import BooksNormal from '@/components/share/books-normal'
import BookTop from '@/components/layer2/book/book-top'

import bookService from '../../../services/bookService'
import shelfService from '../../../services/shelfService'
// import scrollService from '../../../services/scrollService'
import { getImg } from '../../../services/urlService'
import userService from '../../../services/userService'

export default {
  name: 'book-home',
  data () {
    return {
      componentName: '',
      bookInfo: {},
      chapters: [],
      lastChapter: {},
      recommends: [],
      addedToShelf: false,
      history: undefined,
      // showModal: true,
      bookTitle: '',
      showIntro: false
    }
  },

  computed: {
    getContent () {
      const abstractContent = this.bookInfo.abstractContent || ''
      if (abstractContent.length > 75 && !this.showIntro) {
        return abstractContent.substr(0, 75) + '....'
      }
      return abstractContent
    }
  },
  methods: {
    // isShowHistory () {
    //   this.showModal = !this.$router.isBack
    //   this.$router.isBack = true
    // },
    toCatalog () {
      this.$router.isBack = false
      this.$router.push({
        path: `${this.$route.path}/catalog`,
        query: { title: this.bookInfo.title }
      })
    },
    getBookDetail () {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      bookService
        .getDetail(this.$route.params.id)
        .then(res => {
          this.$toast.clear()
          const data = res.data
          this.bookInfo = data.book
          this.chapters = data.chapterList
          this.lastChapter = data.lastChapter
          this.recommends = data.recommendList
          this.bookTitle = data.book.title
          this.isAddedToShelf()
        })
        .catch(() => {
          this.$dialog.confirm({
            message: '网络超时，请刷新重试'
          }).then(() => {
            this.getBookDetail()
          })
        })
    },
    getCoverStyle () {
      const url = this.getCover()
      return `background-image: url(${url})`
    },
    getCover () {
      if (this.bookInfo.horiCover) {
        return getImg(this.bookInfo.horiCover)
      }
    },
    getCoverPlaceholder() {
      if (this.bookInfo.horiCover)
        return `${this.bookInfo.horiCover}_500_0.img`;
    },
    getPriceText (price) {
      if (price === 0 || price === '0') {
        return '免费'
      } else {
        return `${price}阅币`
      }
    },
    addShelf () {
      this.addedToShelf = shelfService.addShelf(this.bookInfo)
    },
    isAddedToShelf () {
      const shelfBook = shelfService.getShelf().find(item => {
        return item.title === this.bookInfo.title
      })
      this.addedToShelf = !!shelfBook
    },
    toReadHandler (type) {
      if (type === 'history') {
        this.toRead(this.history ? this.history.number : 1)
      } else if (type === 'last') {
        this.toRead(this.lastChapter.number)
      } else {
        this.toRead(1)
      }
    },
    toRead (number) {
      number = parseInt(number)
      this.$router.isBack = false
      const book = this.chapters.find(item => item.number === number)
      const title2 = book || ''
      this.$router.push({
        path: `/book/read/${this.bookInfo.bookId}/${number}`,
        query: {
          title: this.bookInfo.title,
          title2: title2
        }
      })
      shelfService.addHistory(this.bookInfo, number)
    },
    getHistory (bookId) {
      this.history = shelfService.getHistoryById(parseInt(bookId))
    }
    // hideModal () {
    //   const obj = document.getElementById('show-history-modal')
    //   obj.style.opacity = 1
    //   this.fadeOut(obj)
    // },
    // fadeOut (obj) {
    //   obj.style.opacity -= 0.05
    //   if (obj.style.opacity > 0) {
    //     setTimeout(() => {
    //       this.fadeOut(obj)
    //     }, 15)
    //   } else {
    //     this.showModal = false
    //   }
    // }
  },
  components: {
    'books-normal': BooksNormal,
    top: BookTop
  },
  mounted () {
    userService.register();

    this.componentName = this.$route.path
    if (
      this.$store.state.pageState[this.componentName] &&
      this.$router.isBack
    ) {
      Object.assign(
        this.$data,
        this.$store.state.pageState[this.componentName].data
      )
      // this.showModal = false
      setTimeout((vue = this) => {
        const scrollDiv = document.getElementById(
          `scroll-div-book-home-${this.$route.params.id}`
        )
        scrollDiv.scrollTop = vue.$store.state.pageState[vue.componentName].top
      }, 5)
    } else {
      // this.isShowHistory()
      this.getBookDetail()
    }
    this.$router.isBack = true
    this.getHistory(this.$route.params.id)
  },
  beforeDestroy () {
    this.$dialog.close()
    this.$toast.clear()
    const scrollDiv = document.getElementById(
      `scroll-div-book-home-${this.bookInfo.bookId}`
    )
    const state = {}
    state[this.componentName] = { data: this.$data, top: scrollDiv.scrollTop }
    this.$store.commit('saveState', state)
  }
}
</script>

<style scoped lang="less">
.intro {
  // height: 100px;
  &.auto {
    height: auto;
  }
}
.more.up {
  img {
    transform: rotate(180deg);
  }
}
</style>
